import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Fade, Zoom } from "react-reveal";

import Counts from "../../components/count/Counts";
import Maps from "../../components/Map/Map";
import { loadDashboardCount } from "../../redux/admin/actions/admin.actions";

import style from "./Dashboard.module.scss";

const Dashboard = () => {
  const dispatch = useDispatch();
  const { dashboardCounts } = useSelector((state) => state.adminReducer);

  useEffect(() => {
    dispatch(loadDashboardCount());
  }, [dispatch]);
  return (
    <div>
      <section className={style.container}>
        <div className={style.textContainer1}>
          <Fade right>
            <div className={style.textContainer}>
              User save as many lives as quickly as you can | Not an Emergency
              order? tell your customer about Nerve
            </div>
          </Fade>
        </div>
        <div className={style.container2}>
          {/* <Search placeholder="Find Any Order..." onChange={handleChange} /> */}
        </div>
      </section>
      <Zoom>
        <Counts
          ongoing={dashboardCounts?.ongoing}
          overdue={dashboardCounts?.overdue}
          completed={dashboardCounts?.completed}
          cancelled={dashboardCounts?.cancelled}
          override={dashboardCounts?.override}
        />
      </Zoom>

      <section
        className={style.menu}
        style={{
          // marginLeft: 0,
          // marginRight: 0,
          justifyContent: "center",
          alignItems: "center",
          // display: "flex",
        }}
      >
        <Row md={12}>
          <Col md={12} className={style.column1}>
            <Maps className={style.map} />
          </Col>
        </Row>
      </section>
    </div>
  );
};

export default Dashboard;
